import clsx from "clsx";
import React, { Component } from "react";
/**
 * Implements a React {@link Component} for the frame of the overlays.
 */
export default class OverlayFrameMobile extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        return (React.createElement("div", { className: this.props.isLightOverlay ? "overlay_mobile__container-light" : "overlay_mobile__container", id: "overlay", style: this.props.style },
            React.createElement("div", { className: clsx("overlay_mobile__content", this.props.contentPosition ? `overlay_mobile__content_${this.props.contentPosition}` : "") }, this.props.children)));
    }
}
